export default "__VITE_ASSET__DWiSb0zs__"